/**
 * Availability gate for the Claude connector's frontend pieces (INH-5704).
 *
 * Every connector feature, in every repo, sits behind a flag that is off in
 * production until Lara says otherwise (2026-10-19). The backend gates its side
 * with the `MCP_CLAUDE_ENABLED` secret; this is the frontend's switch, read by
 * the three places the connector touches:
 *
 * - `src/App.js`: the hand-off route `/consultation/claude/:handoffId`. Off, the
 *   path is not registered and falls through to the not-found page like any
 *   unknown URL.
 * - `src/pages/home-page/Home.js`: the `/home?intent=consultation` landing. Off,
 *   the intent is left in the URL and nothing opens.
 * - `src/hooks/useValidatePageAccess.js`: the sign-in redirect that keeps that
 *   intent through sign-in. Off, a signed-out visit goes to the plain `/signin`.
 *
 * Off is the default everywhere. Turn it on by setting
 * `REACT_APP_CLAUDE_CONNECTOR_ENABLED=true` at build time (Create React App
 * inlines it): in `.env.local` for a local run, and on the Vercel project that
 * builds dev and staging. Never on the production project. Only the exact
 * string "true" counts; any other value, or none, is off.
 */
export const CLAUDE_CONNECTOR_FLAG = "REACT_APP_CLAUDE_CONNECTOR_ENABLED";

export const isClaudeConnectorEnabled = (): boolean =>
  process.env.REACT_APP_CLAUDE_CONNECTOR_ENABLED === "true";
